<div class="relative w-103 rounded-lg neutrals-white-background">
    <div class="w-full relative rounded-lg shadow p-6">
        <div class="flex flex-col gap-4 justify-start items-center">
            <div class="w-full flex items-center justify-between">
                <h3 class="w-full text-lg font-bold primary-purple-text">{{ literalService.get(title, true) }}</h3>
                <img [src]="images.close" class="w-4 h-4 cursor-pointer" alt="close icon" (click)="close.emit()" />
            </div>
            @if (services) {
                @for (service of services; track $index) {
                    @if (service.alterationMessages.length > 0) {
                        <div class="flex flex-col gap-2">
                            <div class="flex justify-start items-center">
                                <app-service-tag [serviceInfo]="service" />
                                <label class="text-base font-bold primary-purple-text ml-2">{{ service.name }}</label>
                            </div>
                            <p class="w-full whitespace-pre-line text-base primary-purple-text">
                                {{ getAlterationsText(service) }}
                            </p>
                        </div>
                    }
                }
            }
        </div>
    </div>
</div>